import { h, Component } from "preact";
import AddToCalendar from "./addToCalender/ReactAddToCalendar";
import SharingLinks from "./SharingLinks";
import { css } from "emotion";
import Button from "../components/Button";
import EventsService from "../services/EventsService";
import { INVOICING } from "../state/actions/orderActions";

const ticket = require("../assets/images/ticket_order_confirmation.svg");
const headingId = "yourOrderDetailsHeading";

const styles = {
  title: css`
    @media (max-width: 600px) {
      font-size: 18px;
    }
  `
};

class CompleteSummary extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    try {
      // document.getElementById(headingId).focus();
    } catch (err) {}
  }

  render() {
    const { order, event, date } = this.props;
    const hideCalendar = event.data.settings.hideAddToCalendar;
    const wrapper = css({
      backgroundColor: "transparent",
      width: 800,
      height: "100%",
      margin: "0 auto",
      backgroundImage: `url(${ticket})`,
      padding: "41px 41px 5px",
      borderRadius: 4,
      marginBottom: 14,
      "@media(max-width: 800px)": {
        width: "100%",
        height: "auto",
        padding: "24px 12px",
        backgroundImage: "none",
        backgroundColor: "#fff"
      }
    });

    const tickets = order.data.tickets ? order.data.tickets : [];

    let eventDate;
    if (event.data.datesUseCalendar) {
      eventDate = date;
    } else {
      event.data.dates.forEach(date => {
        if (String(date._id) === String(order.data.eventDateId)) {
          eventDate = date;
        }
      });
    }

    const parts = [];
    if (event.data.location.venueName) {
      parts.push(event.data.location.venueName);
    }
    if (event.data.location.address) {
      parts.push(event.data.location.address.replace(",", ""));
    }

    const eventCalender = {
      title: event.data.name,
      description: EventsService.getCalendarDescription(event.data),
      location: parts.join(" "),
      startTime: eventDate.startDate,
      endTime: eventDate.endDate
    };

    const organizerEmail =
      event.data.customerContact && event.data.customerContact.email
        ? event.data.customerContact.email
        : "";

    const invoiceSendTicketImmediately =
      event.data &&
      event.data.paymentOptions &&
      event.data.paymentOptions.invoiceInfo &&
      event.data.paymentOptions.invoiceInfo.sendTicketImmediately
        ? event.data.paymentOptions.invoiceInfo.sendTicketImmediately
        : false;

    const isInvoice = order && order.paymentMethod === INVOICING;
    const ticketSent =
      tickets.length > 0 && (!isInvoice || invoiceSendTicketImmediately);
    let ticketsTxt = tickets.length > 1 ? "tickets" : "ticket";
    let ticketsString = `You have purchased ${
      tickets.length > 1 ? `${tickets.length} tickets ` : "a ticket "
    } to `;

    ticketsTxt =
      event &&
      event.data &&
      event.data.settings &&
      event.data.settings.sendTickets
        ? ticketsTxt
        : "order details";
    ticketsString =
      tickets.length === 0 || ticketsTxt === "order details"
        ? "Thank you for your purchase for "
        : ticketsString;

    const ticketsMsg = ticketSent
      ? `along with your ${ticketsTxt} and a tax invoice`
      : `along with your tax invoice`;

    return (
      <div className={wrapper}>
        <h2 tabIndex={-1} id={headingId} className={styles.title}>
          Your order details
        </h2>
        <p style={{ marginBottom: 8 }}>
          {ticketsString}
          <b style={{ fontWeight: 600 }}>{event.data.name}</b> on{" "}
          {eventDate.display.combined}
        </p>

        <p style={{ marginBottom: 8, maxWidth: 600 }}>
          An email confirmation has been sent to{" "}
          <b style={{ fontWeight: 600 }}>{order.data.email}</b> {ticketsMsg}.
          Please make sure to check your spam/junk folder. If email is not
          received within 5 minutes, please contact the organiser{" "}
          <a
            href={`mailto:${organizerEmail}`}
            style={{ textDecoration: "underline" }}
          >
            here
          </a>{" "}
          to resend your order confirmation.
        </p>

        <p style={{ marginBottom: 4 }}>
          Order number:{" "}
          <b style={{ fontWeight: 600 }}>{order.data.orderName}</b>
        </p>
        <p style={{ marginBottom: 24 }}>
          Order date:{" "}
          <b style={{ fontWeight: 600 }}>{order.data.completedDisplayDate}</b>
        </p>
        {!hideCalendar ? (
          <AddToCalendar event={eventCalender}>
            <Button type="secondary">Add to Calendar</Button>
          </AddToCalendar>
        ) : null}
        {event.data.public ? (
          <SharingLinks event={event.data} />
        ) : (
          <div style={{ height: 40 }} />
        )}
      </div>
    );
  }
}
export default CompleteSummary;



// WEBPACK FOOTER //
// ./components/CompleteSummary.js